import Uploady from '@rpldy/uploady'
import React from 'react'

export interface PromptBoxWrapperProps {
  allowedFileTypes: string[]
  children: React.ReactNode
}

/**
 * This wraps the prompt box with the upload context. This is necessary because
 * the context can not be accessed where it was rendered, useContext must be
 * called deeper in the tree; in this case, we're using the context in the
 * `children`, which would be proper PromptBox component
 */
export default function PromptBoxWrapper({ allowedFileTypes, children }: PromptBoxWrapperProps) {
  return (
    <Uploady multiple accept={allowedFileTypes.join(',')}>
      {children}
    </Uploady>
  )
}
